@if (displaySplashScreen) {
  <div
    class="bg-white fixed top-0 bottom-0 left-0 right-0 h-screen px-6 py-12"
    [style.z-index]="90"
  >
    <div class="flex flex-col h-full justify-between">
      <div>
        <div class="flex flex-row justify-start items-center mb-8 text-base">
          @if (kioskInProgress) {
            <img
              src="assets/images/spinner.svg"
              alt=""
              class="mr-4"
            />
          }
          @if (!kioskInProgress && !kiosk) {
            <i class="icon icon-cross text-error-600 mr-4"></i>
          }
          @if (!kioskInProgress && kiosk) {
            <i class="icon icon-check-plain text-success-600 mr-4"></i>
          }
          Connexion au terminal
        </div>
        <div class="mb-8 text-base">
          <div class="flex flex-row justify-start items-center">
            @if (!user) {
              <img
                src="assets/images/spinner.svg"
                alt=""
                class="mr-4"
              />
            }
            @if (user) {
              <i class="icon icon-check-plain text-success-600 mr-4"></i>
            }
            Création d'un profil utilisateur
          </div>
          @if (user) {
            <div class="ml-8 mt-2">
              @if (!user?.[userKeys.IsAnonymous]) {
                <p>
                  {{ user?.[userKeys.FirstName] }}
                  {{ user?.[userKeys.LastName] }}
                </p>
              }
              @if (user?.[userKeys.IsAnonymous]) {
                <p>
                  {{ 'basket.anonymous' | translate }}
                </p>
              }
            </div>
          }
        </div>
      </div>
      @if (kiosk) {
        <div class="text-sm text-center mb-8">
          <p class="font-bold">Terminal</p>
          <p>{{ kiosk.name }}</p>
        </div>
      }
    </div>
  </div>
}
